import { CommonModule } from "@angular/common";
import { Component, Input, input, InputSignal } from "@angular/core";
import { CsIconModule } from "@components/icon";

@Component({
  selector: "hero-ingredients",
  templateUrl: "./hero-ingredients.html",
  standalone: true,
  imports: [CommonModule, CsIconModule],
  styles: [
    `
      :host {
        @apply tw-block tw-mb-6;
      }
    `,
  ],
})
export class HeroIngredientComponent {
  heroIngredients: InputSignal<any[]> = input([]);
  doctorDisplayImage: InputSignal<string> = input("");
  @Input() isRebrandedHeroIngredients: boolean = false;
  isHairReport = input<boolean>(false);
}
